<script lang="ts" setup>
import { useLocalization } from '@/plugins/localization';
import { FormType } from '@/helpers/Form';

export interface FormSettings {
    settings: {
        module: string;
    };
}

defineOptions({
    name: 'widget-mobile-my-points-settings',
});

const { $t } = useLocalization();

const model = defineModel<FormType<FormSettings>>();
</script>

<template>
    <ideo-form-group :label="$t('[[[Moduł]]]')" :description="$t('[[[Klucz modułu aplikacji, do którego przekieruje kliknięcie w widget]]]')">
        <ideo-form-input v-model="model.settings.module" type="text"></ideo-form-input>
    </ideo-form-group>
</template>
